// extracted by mini-css-extract-plugin
export default {"box":"TagInput_box__2QODi","input":"TagInput_input__hbTIO"};